import * as React from 'react';
import * as _ from 'lodash';
import { cleanProps } from '../../utilities/props';
export default function (props, context) {
    function onClick1(e) {
        props.handleCancelClick(e);
    }
    function onClick2(e) {
        props.handleSaveClick(e);
    }
    return React.createElement('div', _.assign({}, cleanProps(props)), React.createElement('div', { 'className': 'lightbox-button-block' }, React.createElement('div', { 'className': 'app-content-footer__buttons' }, !props.hideButtonCancel ? React.createElement('button', {
        'className': 'ui-button ui-button--blue',
        'onClick': onClick1.bind(this),
        'key': '241'
    }, React.createElement('span', { 'className': 'ui-button-text ui-button--uppercase' }, 'Cancel')) : null, !props.hideButtonSave ? React.createElement('button', {
        'className': 'ui-button ui-button--green ui-button--large',
        'onClick': onClick2.bind(this),
        'key': '487'
    }, React.createElement('span', { 'className': 'ui-button-text ui-button--uppercase' }, 'Save'), props.saveCount && props.saveCount > 0 ? React.createElement('span', {
        'className': 'updateCount updateCount--new',
        'key': '730'
    }, '\r\n          ', props.saveCount, '\r\n        ') : null) : null)));
}